import React from "react";
import styled from "styled-components";

const BegrowerLayout = styled.div`
  background-color: #1155cc;
  min-height: 100vh;
    color: #ffffff;
  
  svg {
    fill: #ffffff;
  }
  
  path {
    fill: #ffffff;
  }

  a {
    color: #ffffff;
  }

  input, textarea {
    color: #ffffff;
    background-color: #ffffff;
    border: 1px solid #ffffff;
    &::placeholder {
      color: rgba(0, 0, 0, 0.7);
    }
  }

     .contact-form-button {
       background-color: #1155cc; /* Ejemplo de color de fondo */
       color: #ffffff; /* Ejemplo de color de texto */
       font-size: 1.1rem; /* Ejemplo de tamaño de fuente */
      border: 1px solid #ffffff;
     }


  /* Estilos específicos para el newsletter */
  [name="newsletter"] {
    input {
      background-color: #ffffff;
      color: #000000;
      border: 1px solid #ffffff;
      &::placeholder {
        color: rgba(0, 0, 0, 0.7);
      }
    }
  }

  /* Estilos para los iconos sociales */
  [data-component="social"] {
    svg {
      fill: #ffffff;
    }
    path {
      fill: #ffffff;
    }
  }

`;

const Layout = ({ children }) => {
  return <BegrowerLayout>{children}</BegrowerLayout>;
};

export default Layout; 